import { FlowBlockType } from './type.js';
import { FlowVersionTarget } from '../../flow/versionTarget.js';
const FLOW_BLOCK_TYPES_WITH_SUBFLOW_CONFIG = [
    FlowBlockType.SubFlowV1,
    FlowBlockType.SubFlowV2,
    FlowBlockType.SkillV2,
    FlowBlockType.IteratorV2,
    FlowBlockType.Repeat,
    // These technically still have something like subflow config, but are legacy and doomed for obsolescence
    // FlowBlockType.HCCAlgorithmBlock,
    // FlowBlockType.IteratorV1,
];
export function isFlowBlockWithSubflowConfig(block) {
    if (FLOW_BLOCK_TYPES_WITH_SUBFLOW_CONFIG.includes(block.type)) {
        return true;
    }
    // Deprecated blocks that are still around with legacy sub-flow style configs
    if (block.type === FlowBlockType.IteratorV1) {
        const actionBlock = block.config.action;
        if (actionBlock.type === FlowBlockType.SubFlowV1) {
            // IteratorV1 only ever supported v1 subflows
            return true;
        }
    }
    if (block.type === FlowBlockType.HCCAlgorithmBlock) {
        return true; // All HCCAlgorithm blocks are pinned to specific flowDefinitionIds
    }
    return false;
}
export function extractFlowSubflowConfig(block) {
    if (!isFlowBlockWithSubflowConfig(block)) {
        return undefined;
    }
    switch (block.type) {
        case FlowBlockType.SubFlowV1:
        case FlowBlockType.SubFlowV2:
        case FlowBlockType.SkillV2:
            return block.config;
        case FlowBlockType.IteratorV2:
        case FlowBlockType.Repeat:
            return block.config.subFlow;
        case FlowBlockType.HCCAlgorithmBlock:
            if (block.config.flowDefinitionIds.length === 0) {
                return undefined; // something is wrong with this block, don't blow up
            }
            // We can emulate a pinned subflow config
            return {
                versionTarget: FlowVersionTarget.SpecificVersion,
                flowDefinitionId: block.config.flowDefinitionIds[0],
            };
        case FlowBlockType.IteratorV1:
            if (block.config.action.type === FlowBlockType.SubFlowV1) {
                return block.config.action.config;
            }
            // Action isn't a subflow (and iterator v1 didn't support other block types with subflows)
            // This is technically impossible with the check in isFlowBlockWithSubflowConfig, but we're going
            //  to remove this as soon as IteratorV1 is made obsolete
            return undefined;
    }
}
//# sourceMappingURL=subflowConfig.js.map